import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';
import {IAbacRule} from 'app/blocks/model/abac-rule.model';

export interface IRole extends IBaseEntity {
    id?: number;
    roleName?: string;
    authorityName?: string;
    abacRules?: IAbacRule[];
    readOnly?: boolean;
}

export class Role extends BaseEntity implements IRole {
    id?: number;
    roleName?: string;
    authorityName?: string;
    abacRules?: IAbacRule[];
    readOnly?: boolean;

    constructor(role?) {
        super();
        if (role) {
            this.id = role.id;
            this.roleName = role.roleName;
            this.authorityName = role.authorityName;
            this.abacRules = role.abacRules;
            this.readOnly = role.readOnly;
        }
    }

    clone(): Role {
        return new Role(this);
    }
}
